document.addEventListener("DOMContentLoaded", () => {
  const navSwiper = () => {
    const navSwiperElement = document.querySelector(".nav-swiper");
    const navSwiper = new Swiper(navSwiperElement, {
      init: false,
      slidesPerView: "auto",
      watchOverflow: true,
      freeMode: true,
      mousewheel: {
        enabled: true,
        releaseOnEdges: true,
        forceToAxis: true,
      },
    });
    navSwiper.on("afterInit", () => {
      setTimeout(()=> {
        // allow the overflow to be visible.. This has to be done after init, otherwise the swiper breaks.
        // This is hacky putting it in a timeout. TODO: make this better
        navSwiperElement.style.overflow = "visible";
      }, 2000);
    });

    navSwiper.init();

  };

  document.addEventListener("shopify:section:load", () => {
    navSwiper();
  });

  navSwiper();
});

document.querySelectorAll(".filter-item").forEach((element) => {
  element.addEventListener("click", function () {
    const anchorId = this.dataset.target;
    if (anchorId) {
      const anchorElement = document.getElementById(anchorId);
      if (anchorElement) {
        anchorElement.scrollIntoView({ behavior: "smooth" });
      }
    }
  });
});

const targetElement = document.querySelector(".select-anchor");

targetElement.addEventListener("click", function (event) {
  targetElement.classList.toggle("active");
});

document.addEventListener("click", function (event) {
  if (
    !targetElement.contains(event.target) ||
    event.target.classList.contains("filter-item")
  ) {
    targetElement.classList.remove("active");
  }
});
